<template>
  <div v-for="(item, index) in items.banners" :key="index">
    <div class="flex flex-row w-full gap-4 justify-center bg-strip border-x-0 p-2 text-sm" :class="borderClasses">
      <div class="dark: text-black">
        <div class="text-wrap" v-html="item.content.source"></div>
      </div>
      <div class="text-primary dark:text-black cursor-pointer" @click="handleNavigation(item.action)">
        <div class="text-wrap" v-html="item.meta?.footer"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['items', 'config']);

const handleNavigation = (action) => {
  if (action.type === 'external') {
    navigateTo(action.target, { external: true });
  }
  navigateTo({ path: action.target });
}
const borderClasses = props.config.border ? 'ring-2 ring-stone-200' : '';
</script>

<style scoped>
.bg-strip {
  background-color: #FEF0CA;
}
</style>
